import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { NotFoundViewComponent } from './shared/views';

const routes: Routes = [
  {
    path: 'back-office',
    loadChildren: () => import('./back-office-app/back-office-app.module').then(m => m.BackOfficeAppModule),
  },
  {
    path: '',
    loadChildren: () => import('./customer-app/customer-app.module').then(m => m.CustomerAppModule),
  },
  {
    path: '**',
    component: NotFoundViewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class RootRoutingModule {}
